import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Grid,
  Button,
  CircularProgress,
} from '@mui/material';

const Detail = () => {
  const { linkId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { item } = location.state || {};
  const [loading, setLoading] = useState(false);

  if (!item) {
    navigate('..');
    return null;
  }

  const updateStatus = async (actionType) => {
    setLoading(true);
    try {
      await fetch('https://approve.mydeapi.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-key': 'JZ5QplfUbSMXFd2wbsss6F3M9feB4Gi7zWWhVRN4' },
        body: JSON.stringify({
          action: actionType,
          payload: {
            id_solicitacao: item.id, 
            id_link: linkId,
          },
        }),
      });
      navigate('..', { replace: true });
    } catch (error) {
      console.error('Erro ao atualizar o item:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" style={{ marginTop: '20px' }}>
      <Paper style={{ padding: '20px' }}>
        <Typography variant="h5" gutterBottom>
          Detalhes do Caso
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">
              <strong>Número do Chamado:</strong> {item.numeroChamado}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Data de Débito:</strong> {item.dataDebito}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Valor do Débito:</strong> {item.valorDebito}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Status:</strong> {item.status}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1">
              <strong>Telefone:</strong> {item.telefone}
            </Typography>
            <Typography variant="subtitle1">
              <strong>CPF:</strong> {item.cpf}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Matrícula:</strong> {item.matricula}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Convênio:</strong> {item.convenio}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              <strong>Dados Bancários:</strong> {item.dadosBancarios}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Motivo do Cancelamento:</strong> {item.motivoCancelamento}
            </Typography>
            <Typography variant="subtitle1">
              <strong>Outros Códigos:</strong> {item.outrosCodigos}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginTop: '20px' }}>
          <Grid item>
            <Button
              variant="contained"
              color="success"
              onClick={() => updateStatus('APROVAR')}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Aprovar'}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="error"
              onClick={() => updateStatus('REPROVAR')}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Reprovar'}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('..')}
              disabled={loading}
            >
              Voltar para a Home
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default Detail;
